import { render, staticRenderFns } from "./BrandOrder.vue?vue&type=template&id=26d7e025&lang=pug"
import script from "./BrandOrder.vue?vue&type=script&lang=js"
export * from "./BrandOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports